import { Injectable } from '@angular/core';
import { LearningUnitJsonModel } from './learning-unit.json.model';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';

@Injectable({
  providedIn: 'root'
})
export class LearningUnitService extends BaseCollectionService<LearningUnitJsonModel, AppCollection> {
  protected ctor = LearningUnitJsonModel;
}
